import React, { useState, useEffect, useRef } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
export default function ProductDetails() {
    const tabRef = useRef(null);
    const product = {
        name: "AirSound Max Wireless Headphones",
        price: 2999,
        oldPrice: 3999,
        rating: 4.7,
        images: [
            "https://picsum.photos/800/800?1",
            "https://picsum.photos/800/800?2",
            "https://picsum.photos/800/800?3",
            "https://picsum.photos/800/800?4"
        ],
        description:
            "Ultra premium wireless headphones with adaptive noise cancellation and spatial audio."
    };
    const [mainImage, setMainImage] = useState(product.images[0]);
    const [quantity, setQuantity] = useState(1);
    const [tab, setTab] = useState("desc");
    const [color, setColor] = useState("black");
    const [wishlist, setWishlist] = useState(false);
    useEffect(() => {
        const activeBtn = tabRef.current.querySelector(".active");
        const indicator = tabRef.current.querySelector(".tab-indicator");

        if (activeBtn && indicator) {
            indicator.style.width = `${activeBtn.offsetWidth}px`;
            indicator.style.left = `${activeBtn.offsetLeft}px`;
        }
    }, [tab]);
    return (
        <div className="page-container">
            <Header />
            <div className="premium-product">
                <div className="product-layout">
                    <div className="image-area">
                        <div className="zoom-container">
                            <img src={mainImage} className="main-img" />
                        </div>
                        <div className="thumb-row">
                            {product.images.map((img, i) => (
                                <img key={i} src={img} onClick={() => setMainImage(img)} />
                            ))}
                        </div>
                    </div>
                    <div className="info-area">
                        <h1>{product.name}</h1>
                        <div className="rating">⭐ {product.rating} / 5 (132 Reviews)</div>
                        <div className="price-box">
                            <span className="price">₹{product.price}</span>
                            <span className="old">₹{product.oldPrice}</span>
                            <span className="discount">25% OFF</span>
                        </div>
                        <div className="variant">
                            <p>Color</p>
                            <div className="color-options">
                                <div className={`color black ${color === "black" ? "active" : ""}`}
                                    onClick={() => setColor("black")}></div>
                                <div className={`color red ${color === "red" ? "active" : ""}`}
                                    onClick={() => setColor("red")}></div>
                                <div className={`color blue ${color === "blue" ? "active" : ""}`}
                                    onClick={() => setColor("blue")}></div>
                            </div>
                        </div>
                        <div className="qty">
                            <button onClick={() => setQuantity(quantity > 1 ? quantity - 1 : 1)}>-</button>
                            <span>{quantity}</span>
                            <button onClick={() => setQuantity(quantity + 1)}>+</button>
                        </div>
                        <div className="delivery">
                            <input placeholder="Enter Pincode" />
                            <button>Check</button>
                        </div>
                        <div className="action">
                            <button className="cart">Add to Cart</button>
                            <button className="buy">Buy Now</button>
                            <button className="wish" onClick={() => setWishlist(!wishlist)}>{wishlist ? "❤️" : "🤍"}</button>
                        </div>
                    </div>
                </div>
                <div className="tabs">
                    <div className="tab-header" ref={tabRef}>
                        {["Description", "Specifications", "Shipping"].map((t) => (
                            <button
                                key={t}
                                className={tab === t.toLowerCase() ? "active" : ""}
                                onClick={() => setTab(t.toLowerCase())}
                            >
                                {t}
                            </button>
                        ))}
                        <span className="tab-indicator" />
                    </div>
                    <div className="tab-body">
                        {tab === "description" && (
                            <div className="tab-content">
                                <p>
                                    Experience immersive sound with spatial audio, adaptive ANC, and 40 hours of battery life.
                                </p>
                            </div>
                        )}
                        {tab === "specifications" && (
                            <div className="tab-content">
                                <ul>
                                    <li>Bluetooth 5.3</li>
                                    <li>40h Battery Life</li>
                                    <li>Fast Charge</li>
                                    <li>Spatial Audio Support</li>
                                </ul>
                            </div>
                        )}
                        {tab === "shipping" && (
                            <div className="tab-content">
                                <p>Delivery within 2-4 business days. Free shipping for orders above ₹2000.</p>
                            </div>
                        )}
                    </div>
                </div>
                <div className="related">
                    <h2>Related Products</h2>
                    <div className="grid">
                        {[1, 2, 3, 4].map((item, i) => (
                            <div className="card" key={i}>
                                <img src={`https://picsum.photos/400/400?${i}`} />
                                <h4>Premium Product</h4>
                                <p>₹1999</p>
                            </div>
                        ))}
                    </div>
                    <div className="sticky-cart">
                        <span>₹{product.price}</span>
                        <button>Add to Cart</button>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}